
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { putWriteOff } from "@/api/credit-note"
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "强制核销" }) private title: "";
  @Prop({ default: {} }) private selectedItem: any;

  // @Watch("show", { immediate: true })
  // private async watchData() {
  //   if ((this.selectedItem as any).id && this.show) {
  //     this.form = deepClone(this.selectedItem);
  //   }
  // }

  private form = {writeOffReason: '',writeOffAmount: 0} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "S/N",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "HQ交易号码",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "询价参照号",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "参照号类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "交货进度",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    }
  ];
  private list = [
    {
      label: "核销金额",
      prop: "writeOffAmount",
      key: "writeOffAmount",
      type: "inputNumber",
      placeholder: "核销金额",
      clearable: true,
      maxlength: 10,
    },
    {
      label: "核销原因",
      prop: "writeOffReason",
      key: "writeOffReason",
      type: "textarea",
      placeholder: "请输入核销原因",
      clearable: true,
      maxlength: 50,
      rules: {
        required: true,
        message: "请输入核销原因",
        trigger: "blur"
      },
    },
  ];
  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            await putWriteOff(this.selectedItem.id,this.form)
            this.$notify({
              title: "成功",
              message: "核销成功",
              type: "success",
              duration: 2000
            });
            this.close();
            this.$emit("success", false);
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
